import Styles from "./home.module.css";
import { HomeImage, SearchSection } from "./home_components.js";
import testImg1 from "../../images/halloween (1).png";
import testImg2 from "../../images/halloween (2).png";
import testImg3 from "../../images/halloween (3).png";
import testImg4 from "../../images/halloween (4).png";
import testImg5 from "../../images/halloween (5).png";
export const HomeBody = ( props ) => {
    const {  } = props;
    const { Body, Content } = Styles;
    const data = {
        images: [ testImg1, testImg2, testImg3, testImg4, testImg5 ],
        search: [
            { id: "12wnu92hfp29", name: "hello, world!",              category: ["code", "programme", "video", "educational"], title: "Introduction 🌍👋", link: null },
            { id: "1256gu92hfp2", name: "samantha",                  category: ["work", "job", "team", "tutor"], title: "Team Member 👩‍🏫", link: null },
            { id: "34xzq12mno34", name: "learning python",           category: ["code", "programming", "video", "educational"], title: "Programming Course 🐍📚", link: null },
            { id: "78abc45def67", name: "project management",        category: ["work", "job", "team", "skills"], title: "Management Skills 📊", link: null },
            { id: "90klm34nop56", name: "data science basics",       category: ["code", "education", "video", "analysis"], title: "Data Science 📈🔍", link: null },
            { id: "21opq56rst89", name: "effective communication",   category: ["work", "team", "skills", "training"], title: "Communication Skills 💬", link: null },
            { id: "67uvwx89yz12", name: "intro to machine learning", category: ["code", "educational", "video", "tech"], title: "Machine Learning 🤖", link: null },
            { id: "89asj12kdf34", name: "web development basics",    category: ["code", "programming", "video", "education"], title: "Web Development 🌐💻", link: null },
            { id: "56djk34lkj12", name: "team collaboration tools",  category: ["work", "team", "skills", "training"], title: "Collaboration Tools 🤝", link: null },
            { id: "32fjw45gtr67", name: "digital marketing strategies", category: ["work", "marketing", "video", "business"], title: "Marketing Strategies 📈📣", link: null },
            { id: "19bcd45tgh23", name: "financial analysis",        category: ["work", "finance", "video", "analysis"], title: "Financial Analysis 💹", link: null },
            { id: "45klm56nop78", name: "intro to data visualization", category: ["code", "education", "video", "analysis"], title: "Data Visualization 📊", link: null },
            { id: "78hjf12lmn45", name: "social media marketing",    category: ["work", "marketing", "video", "business"], title: "Social Media Marketing 📱📣", link: null },
            { id: "93opq12rst56", name: "public speaking skills",    category: ["work", "team", "skills", "training"], title: "Public Speaking 🎤", link: null },
            { id: "27xyz34abc90", name: "user experience design",    category: ["code", "design", "video", "education"], title: "UX Design 🎨", link: null },
            { id: "11abc22def33", name: "machine learning basics",   category: ["code", "educational", "video", "tech"], title: "Machine Learning Basics 📚🤖", link: null },
            { id: "15qaz23wsx12", name: "agile project management",  category: ["work", "job", "team", "skills"], title: "Agile Management ⏳", link: null },
            { id: "98klm65qwe34", name: "cybersecurity fundamentals", category: ["code", "education", "video", "tech"], title: "Cybersecurity 🔒", link: null },
            { id: "62rty45fgh90", name: "cloud computing concepts",   category: ["code", "educational", "video", "tech"], title: "Cloud Computing ☁️", link: null },
            { id: "53rew67uio12", name: "data analysis with R",      category: ["code", "education", "video", "analysis"], title: "Data Analysis with R 📊🔍", link: null },
            { id: "84asd56dfg78", name: "SEO best practices",        category: ["work", "marketing", "video", "business"], title: "SEO Practices 🔍📈", link: null },
            { id: "10zxc12vbn34", name: "content writing tips",      category: ["work", "writing", "video", "education"], title: "Writing Tips ✍️📚", link: null }
        ],
        placeholders: [
            "Happy Halloween! 🎃",
            "Explore our projects! 🛠️",
            "Watch our courses! 📚",
            "Spooky savings await! 💰👻",
            "Latest project updates! 🔍",
            "Enhance your skills! 🧠",
            "Treat yourself to new products! 🍬🛍️",
            "Dive into innovation! 🌊",
            "Learn something new! 🎓",
            "Don't miss our Halloween events! 🎊",
            "Try thrilling Halloween recipes! 🍽️",
            "Get creative with DIY! 🎨",
            "Inspire with haunting designs! 🖌️",
            "Join our Halloween workshops! 🏫",
            "Share your spooktacular ideas! 💭",
            "Find the perfect costume! 🎭",
            "Join fun Halloween challenges! 🤝",
            "Explore Halloween traditions! 📜",
            "Have a ghoulishly good time! 👻",
            "Check out our Halloween merch! 🛒",
            "Celebrate a month of festivities! 🎉"
        ]
    };
    return (
        <main className={ Body }>
            <main className={ Content }>
                <HomeImage images={ data.images }/>
                <SearchSection search={ data.search } placeholders={ data.placeholders }/>
            </main>
        </main>
    );
};